import { WorkspacesFilters } from "./WorkspacesFilters";
import { WorkspacesMap } from "./WorkspacesMap";

type WorkspacesCompound = {
  Filters: typeof WorkspacesFilters;
  Map: typeof WorkspacesMap;
};

/** The workspaces tab's parts. Each renders nothing on other tabs. */
export const Workspaces: WorkspacesCompound = {
  Filters: WorkspacesFilters,
  Map: WorkspacesMap,
};
